import { combineReducers } from 'redux';
import alertReducer from './AlertMessages/reducer';

export default combineReducers({
    alertReducer
});
